export default "__VITE_ASSET__DK6lQ$wo__"